export function formatJidAsPhone(jid) {
  if (!jid) return "Chat";
  const idPart = String(jid).split("@")[0];
  if (!/^\d+$/.test(idPart)) return idPart;
  
  let numStr = idPart;
  if (numStr.startsWith("521") && numStr.length === 13) {
    return `+52 1 ${numStr.slice(3, 5)} ${numStr.slice(5, 9)} ${numStr.slice(9)}`;
  } else if (numStr.startsWith("52") && numStr.length === 12) {
    return `+52 ${numStr.slice(2, 5)} ${numStr.slice(5, 8)} ${numStr.slice(8)}`;
  } else if (numStr.startsWith("1") && numStr.length === 11) {
    return `+1 ${numStr.slice(1, 4)} ${numStr.slice(4, 7)} ${numStr.slice(7)}`;
  } else {
    if (numStr.length >= 10 && numStr.length <= 15) {
      const last4 = numStr.slice(-4);
      const prev3 = numStr.slice(-7, -4);
      const prev3_2 = numStr.slice(-10, -7);
      const remainder = numStr.slice(0, -10);
      return `+${remainder} ${prev3_2} ${prev3} ${last4}`.trim();
    }
    return `+${numStr}`;
  }
}
